export default __webpack_public_path__ + "static/media/dashboardEllipsesGreen.c477ba51.svg";